import React, { useEffect, useRef, useState } from 'react'
import { Content } from 'antd/es/layout/layout'
import PAQ from '../shop-front-component/PAQ'

import { useNavigate } from 'react-router-dom'
import { Breadcrumb, Collapse, Image, Select, Tooltip } from 'antd'
import { CFCDN, toAwning } from '../shop-front-component/ProductCollection'

import {  colourType, controlType, motoBrand, protectaCatalogsZipImages, protectaOperarions, protectaSystemBottomColor, protectaSystemChannelColor, protectaSystemColor, protectaSystemHoodColor } from './data'


import { ArrowLeftOutlined,ArrowRightOutlined,LoadingOutlined } from '@ant-design/icons';


export default function ZipAwningPage() {
    const navigate = useNavigate()
    const [currentImage,setCurrentImage] = useState(CFCDN+"protecta/protecta-white-zip.png")
    const [currentImageList,setCurrentImageList] = useState([
        CFCDN+"protecta/protecta-white-zip.png",
        CFCDN+"product-cover/zip-cover.jpg",
        CFCDN+"product-cover/zip-awning/IMG_0508.jpg",
        CFCDN+"product-cover/zip-awning/IMG_0509.jpg",
        CFCDN+"product-cover/zip-awning/IMG_0497.JPG",
        CFCDN+"product-cover/zip-awning/IMG_0498.JPG",
        CFCDN+"product-cover/zip-awning/IMG_0502.JPG",
        CFCDN+"product-cover/zip-awning/IMG_0504.JPG",
        CFCDN+"product-cover/zip-awning/IMG_0510.jpg",
        CFCDN+"product-cover/zip-awning/IMG_0515.jpg",
        CFCDN+"product-cover/zip-awning/IMG_0516.jpg",
        CFCDN+"product-cover/zip-awning/IMG_0517.jpg",
        CFCDN+"product-cover/zip-awning/IMG_0520.JPG",
        CFCDN+"product-cover/zip-awning/IMG_0523.jpg",
        CFCDN+"product-cover/zip-awning/IMG_6830.png",
    ])
    const [currentFabric, setCurrentFabric] = useState<number>()
    const [currentColour, setCurrentColour] = useState<number>()
    const [currentColourTitle, setCurrentColourTitle] = useState<string>("")
    const [currentColourList, setCurrentColourList] = useState<colourType[]>([])
    const [currentColourDescription, setCurrentColourDescription] = useState<string>("")
    const [currentSystemColor, setCurrentSystemColor] = useState<number>()
    const [currentBottomColor, setCurrentBottomColor] = useState<number>()
    const [currentChannelColor, setCurrentChannelColor] = useState<number>()
    const [currentControlType, setCurrentControlType] = useState<number>()
    const [currentMotorBrand, setCurrentMotorBrand] = useState<number>()
    const [wifiControl,setWifiControl] = useState(false)
    const [manualOverdrive,setManualOverdrive] = useState(false)
    const [controlTypes,setControlTypes] = useState([])
    const [control,setControl] = useState<number>()

    const [installation,setInstallation] = useState(false)
    const [opticalDetection,setOpticalDetection] = useState(false)
    const   [scrollPosition,setScrollPosition] = useState(0)
    const   containerRef = useRef<HTMLDivElement>(null);;
    useEffect(() => {
        // Initial load of images
        fetchMoreImages();
    }, []);

    useEffect(() => {
        const container = containerRef.current;
        
        const onScroll = () => {
            if (container){
                if (container.scrollLeft + container.clientWidth >= container.scrollWidth) {
                    fetchMoreImages();
                }
            }
            
        };

        if (container) {
            container.addEventListener('scroll', onScroll);
        }

        return () => {
            if (container) {
                container.removeEventListener('scroll', onScroll);
            }
        };
    }, [currentImageList]);

    const fetchMoreImages = () => {
        // Mock fetching more images (replace with your actual fetch logic)
        const newImages = [
            CFCDN+"protecta/protecta-white-zip.png",
            CFCDN+"product-cover/zip-cover.jpg",
            CFCDN+"product-cover/zip-awning/IMG_0508.jpg",
            CFCDN+"product-cover/zip-awning/IMG_0509.jpg",
            CFCDN+"product-cover/zip-awning/IMG_0497.JPG",
            CFCDN+"product-cover/zip-awning/IMG_0498.JPG",
            CFCDN+"product-cover/zip-awning/IMG_0502.JPG",
            CFCDN+"product-cover/zip-awning/IMG_0504.JPG",
            CFCDN+"product-cover/zip-awning/IMG_0510.jpg",
            CFCDN+"product-cover/zip-awning/IMG_0515.jpg",
            CFCDN+"product-cover/zip-awning/IMG_0516.jpg",
            CFCDN+"product-cover/zip-awning/IMG_0517.jpg",
            CFCDN+"product-cover/zip-awning/IMG_0520.JPG",
            CFCDN+"product-cover/zip-awning/IMG_0523.jpg"
        ]
        setCurrentImageList(prevList => [...prevList, ...newImages]);
    };

    const handleScroll = (scrollOffset:number) => {
        if(containerRef.current){
            containerRef.current.scrollBy({ left: scrollOffset, behavior: 'smooth' });
        }   
        
    };


    const catalogOptions = protectaCatalogsZipImages?.map((type) => {
        return {
          label: type.title,
          value: type.id,
          key: type.id,
        };
      });

      const catalogMotors = protectaOperarions?.map((type) => {
        return {
          label: type.description,
          value: type.id,
          key: type.id,
        };
      });

    const handleFabricChanges = (e:any)=>{
        const fabricCatalog = protectaCatalogsZipImages.find(
            (item) => item.id === e,
          );
         
        if (fabricCatalog?.colours){
            setCurrentColourList(fabricCatalog?.colours)
            loadFabricColor(fabricCatalog?.colours)
        }
       
        
    }


        const scrollToParentEnd = (parentDevStr:string) => {
            const parentDiv = document.getElementById(parentDevStr); // Replace with your actual parent div id
            if (parentDiv) {
            const parentRect = parentDiv.getBoundingClientRect();
            window.scrollTo({
                top: parentRect.bottom + window.scrollY - window.innerHeight + 500,
                behavior: 'smooth',
            });
            }
        };
        /// LOAD MANAGEMENT

        const preloadImages = (srcArray: string[]): Promise<void[]> => {
            return Promise.all(
            srcArray.map(src => {
                return new Promise<void>((resolve, reject) => {
                const img = new window.Image();
                img.src = src;
                img.onload = () => resolve();
                img.onerror = reject;
                });
            })
            );
        };
        const [loading, setLoading] = useState(true);
        
        const [loadingFabricColor, setLoadingFabricColor] = useState(true);
        const [loadingRemote, setLoadingRemote] = useState(true);
        useEffect(() => {
            const imageSources = currentImageList.map(item => item);
            preloadImages(imageSources)
            .then(() => setLoading(false))
            .catch(err => {setLoading(false); console.error('Failed to preload images', err)})
        }, []);
        
        const loadFabricColor = (srcArray: colourType[]) =>{
            setLoadingFabricColor(true)
            const imageSources = srcArray.map(item => item.src);
            preloadImages(imageSources)
            .then(() => setLoadingFabricColor(false))
            .catch(err => {setLoadingFabricColor(false); console.error('Failed to preload images', err)})
        }
        
        
        const loadRemote = (srcArray: colourType[]) =>{
            setLoadingRemote(true)
            const imageSources = srcArray.map(item => item.src);
            preloadImages(imageSources)
            .then(() => setLoadingRemote(false))
            .catch(err => {setLoadingRemote(false); console.error('Failed to preload images', err)})
        }
        if (loading) {
            return  <div className='hedvig-letters-sans-regular  p-1 flex items-center justify-center h-[100vh] w-full bg-white'>
            <Content className=' bg-transparent max-w-screen-2xl m-auto px-2 flex items-center justify-center'>
                <LoadingOutlined color="#000000" style={{fontSize:40}}/>
            </Content>
            </div>
          }
  return (
      <div className='hedvig-letters-sans-regular bg-white p-1'>
            <Content className=' bg-transparent max-w-screen-2xl m-auto px-2'>
                
            
                <div className=" mx-auto gap-5 h-[fit] mt-5">
                    <div className="flex flex-col lg:flex-row gap-5 ">
                        {/* Left Column */}
                        <div className=' w-full lg:w-7/12 '>
                            <div className='sticky top-32 '>
                                <div className='w-full aspect-video overflow-hidden border-none bg-white rounded-lg mx-auto overflow-hidden' >
                                                <Image
                                                    src={currentImage}      
                                                    alt="Centered Image"
                                                    height={"100%"}
                                              
                                                    className="transform object-cover object-center"
                                                /> 
                                                
                                </div>
                                <div className='relative gap-3 flex flex-row group justify-center items-center'>
                                    <div className=' absolute shrink-0 rounded-md left-0 z-50 bg-white !h-[3rem] !w-[3rem] opacity-30 flex items-center justify-center hover:opacity-100 group-hover:opacity-100 transform-all duration-300'
                                            onClick={()=>{handleScroll(-300)}}
                                        >
                                            <span className='text-black'><ArrowLeftOutlined></ArrowLeftOutlined></span>
                                        </div>
                                    <div className='flex flex-row gap-2 mt-2 overflow-scroll no-scrollbar  scroll-smooth'
                                        ref={containerRef}
                                    >
                                    
                                        {currentImageList.map((item,index)=>{
                                            return(
                                                <div key={index}
                                                    onClick={()=>{setCurrentImage(item)}}
                                                >
                                                    <img
                                                    className={`object-center object-cover w-[10rem] aspect-video rounded-lg shadow-md  ${(currentImage == item)?'border-2 border-solid  border-blue-500 ' :'border border-solid  border-gray-100'} transform-all duration-100`}
                                                    alt=""
                                                    src={item}
                                                    
                                                />
                                                </div>
                                                
                                            )
                                        })}
                                        
                                    </div>
                                    <div className='absolute shrink-0 rounded-md right-0 z-50 bg-white !h-[3rem] !w-[3rem] opacity-30 flex items-center justify-center hover:opacity-100 group-hover:opacity-100 transform-all duration-300'
                                            onClick={()=>{handleScroll(300)}}
                                        >
                                            <span className='text-black'><ArrowRightOutlined></ArrowRightOutlined></span>
                                        </div>
                                    </div>
                                    
                            </div>
                            
                        </div>

                        {/* Right Column */}
                        
                        <div className="w-full lg:w-5/12  border-none flex flex-col lg:pl-5">
                        <div className='flex flex-row  mt-10 justify-between p-2'>
                            <Breadcrumb
                                items={[
                                    {
                                        title: <span onClick={()=>{navigate('/')}} className=' hover:underline hover:-translate-y-1 duration-300 transition-transform '>Home</span>,
                                    },
                                    {
                                        title: <span onClick={()=>{navigate('/products/awnings')}} className=' hover:underline hover:-translate-y-1 duration-200 transition-transform '>Awnings</span>,
                                    },
                                    {
                                        title: 'Protecta Zip Awnings',
                                    },
                                ]}
                            />
                        
                        </div>
            
                        <div className=' w-full  flex flex-col'>
                            {/* <span className='hedvig-letters-serif-regular text-6xl  my-5'>
                                Protecta Zip Awnings
                            </span> */}
                            <div className=' flex flex-col my-5 h-fit '>
                                <span className='hedvig-letters-serif-regular text-6xl '>
                                    Protecta Zip Awnings
                                </span>
                                <span className='hedvig-letters-sans-regular text-xl text-neutral-700 mt-5 '>
                                    From $849.12
                                </span>
                                <span className='hedvig-letters-sans-regular text-lg text-neutral-500 mt-5 '>
                                Built to withstand weather conditions un-matchable by any other awning or external blind on the Australian market. Wind, rain or sunshine, this system is built to withstand them all. Create additional rooms & private spaces by extending your outdoor living while remaining protected from sun, wind, rain and those pesky insects.
                                </span>
                        
                       
                            </div>
                            <Collapse
                                    size='large'
                                    defaultActiveKey={['1']}
                                    className='my-2'
                                    items={[{ key: '1', label: 'Fabric', 
                                    children: 
                                    <div>
                                        <div className={`flex flex-col`} id='fabricBrand'>
                                            <span className='hedvig-letters-sans-regular text-xl text-black p-2'>Select Fabric:</span>
                                            <div className='flex flex-col gap-3  p-2'>
                                                    {protectaCatalogsZipImages?.map((item:any,index:number) =>{
                                                            return(
                                                            
                                                                    <div
                                                                    key={index}
                                                                    className={`w-full h-[10rem] cursor-pointer flex flex-row items-center justify-center overflow-hidden rounded-lg  bg-transparent ${(currentFabric == index)?'border-2 border-solid  border-blue-500 ' :'border border-solid  border-gray-100'} shadow-md transform-all duration-200`}
                                                                    onClick={()=>{
                                                                    handleFabricChanges(item.id)
                                                                    setCurrentFabric(index)
                                                                    scrollToParentEnd('fabricBrand')
                                                                    setCurrentImage(item.src)
                                                                    }}
                                                                    >
                                                                        
                                                                            <img
                                                                            
                                                                                className="object-center object-cover w-2/5 h-full"
                                                                                alt=""
                                                                                src={item.src}
                                                                            />
                                                                            <div className='flex flex-col p-2 h-full w-2/3'>
                                                                                <span className='text-lg '>{item.title}</span>
                                                                                {item.desc.map((i:string,index:number)=>{
                                                                                return(
                                                                                    <div key={index} className='flex flex-row gap-2'>
                                                                                    <span className='text-sm text-neutral-500'>•</span>
                                                                                    <span className='text-sm text-neutral-500'>{i}</span>
                                                                                    </div>
                                                                                    
                                                                                )
                                                                                })}
                                                                                
                                                                            </div>
                                                                        
                                                                    </div>
                                                    
                                                            )
                                                    })}
                                                
                                                </div>
                                        </div>
                                        <div className={`flex flex-col  mt-5 ${currentFabric==undefined ? 'hidden':''}`} id='fabricColor'>
                                            <span className='hedvig-letters-sans-regular text-xl text-black p-2'>Fabric Color:</span>
                                            {(loadingFabricColor)?
                                                    <div className='flex items-center justify-center'>
                                                         <LoadingOutlined color="#000000" style={{fontSize:40}}/>
                                                    </div>
                                                   
                                                    :
                                            <div className='grid grid-cols-3 xl:grid-cols-4 gap-3 p-2'>
                                                {currentColourList?.map((item:any,index:number) =>{
                                                        return(
                                                        
                                                                <div
                                                                key={index}
                                                                className={`cursor-pointer flex flex-col items-center justify-center overflow-hidden rounded-lg  bg-transparent ${(currentColour == index)?'border-2 border-solid  border-blue-500 -translate-y-1' :'border border-solid  border-gray-100'} shadow-md transform-all duration-200`}
                                                                onClick={()=>{
                                                                    setCurrentImage(item.src);
                                                                    setCurrentColour(index)
                                                                    setCurrentColourTitle(item.title)
                                                                    scrollToParentEnd('fabricColor')
                                                                }}
                                                                >
                                                                        <img
                                                                            className="object-center object-cover w-full h-full "
                                                                            alt=""
                                                                            src={item.src}
                                                                        />
                                                            
                                                                    <span className='text-xs my-2'>{item.title}</span>
                                                                </div>
                                                
                                                                )
                                                            })}
                                            </div>}
                                        </div>
                                    </div>
                                }]}
                                />
                            <Collapse
                                    size='large'
                                    defaultActiveKey={['1']}
                                    className='my-2'
                                    items={[{ key: '1', label: 'Hood Cover', 
                                    children: 
                                    <div className=' w-full flex flex-col' id='hood'>
                                    <span className='hedvig-letters-sans-regular text-xl text-black p-2'>Hood Colour:</span>
                                    <div className='flex flex-wrap gap-2 mt-1 p-2'>
                                    {protectaSystemHoodColor?.map((item:any,index:number) =>{
                                        return(
                                            <Tooltip key={index} placement="bottom" title={item.title}>
                                                <div
                                                
                                                style={{ width: 50, height:50 }}
                                                className={`cursor-pointer rounded-full flex flex-col items-center justify-center overflow-hidden  bg-transparent ${(currentSystemColor == index)?'border-4 border-solid  border-blue-500 -translate-y-1' :'border border-solid border-neutral-200'} shadow-md shadow-md transform-all duration-200`}
                                                onClick={()=>{
                                                    setCurrentSystemColor(index)
                                                    // setCurrentImage(item.src)
                                                    setCurrentColourTitle("Please note the product color may slightly differ from the render.")
                                                    scrollToParentEnd('hood')
                                                }}
                                                >
                                                    <div style={{ width: 75, height:75, background:item.color }} ></div>
                                                </div>
                                        </Tooltip>
                                        )
                                    })}
                                    
                                    </div>
                                   
                                </div>

                                }]}
                                />
                                <Collapse
                                    size='large'
                                    defaultActiveKey={['1']}
                                    className='my-2'
                                    items={[{ key: '1', label: 'Side Channel', 
                                    children: 
                                    <div className=' w-full flex flex-col' id='channel'>
                                    <span className='hedvig-letters-sans-regular text-xl text-black p-2'>Side Channel Colour:</span>
                                    <div className='flex flex-wrap gap-2 mt-1 p-2'>
                                    {protectaSystemChannelColor?.map((item:any,index:number) =>{
                                        return(
                                            <Tooltip key={index} placement="bottom" title={item.title}>
                                                <div
                                                
                                                style={{ width: 50, height:50  }}
                                                className={`cursor-pointer rounded-full flex flex-col items-center justify-center overflow-hidden  bg-transparent ${(currentChannelColor == index)?'border-4 border-solid  border-blue-500 -translate-y-1' :'border border-solid border-neutral-200'} shadow-md shadow-md transform-all duration-200`}
                                                onClick={()=>{
                                                    setCurrentChannelColor(index)
                                                    // setCurrentImage(item.src)
                                                    setCurrentColourTitle("Please note the product color may slightly differ from the render.")
                                                    scrollToParentEnd('channel')
                                                }}
                                                >
                                                    <div style={{ width: 75, height:75 , background:item.color }} ></div>
                                                </div>
                                        </Tooltip>
                                        )
                                    })}
                                    
                                    </div>
                           

                                </div>
                                }]}
                                />
                                <Collapse
                                    size='large'
                                    defaultActiveKey={['1']}
                                    className='my-2'
                                    items={[{ key: '1', label: 'Bottom Bar', 
                                    children: 
                                    <div className=' w-full flex flex-col' id='bottom'>
                                    <span className='hedvig-letters-sans-regular text-xl text-black p-2'>Bottom Bar Colour:</span>
                                    <div className='flex flex-wrap gap-2 mt-1 p-2'>
                                    {protectaSystemBottomColor?.map((item:any,index:number) =>{
                                        return(
                                            <Tooltip key={index} placement="bottom" title={item.title}>
                                                <div
                                                
                                                style={{ width: 50, height:50 }}
                                                className={`cursor-pointer rounded-full flex flex-col items-center justify-center overflow-hidden  bg-transparent ${(currentBottomColor == index)?'border-4 border-solid  border-blue-500 -translate-y-1' :'border border-solid border-neutral-200'} shadow-md shadow-md transform-all duration-200`}
                                                onClick={()=>{
                                                    setCurrentBottomColor(index)
                                                    // setCurrentImage(item.src)
                                                    setCurrentColourTitle("Please note the product color may slightly differ from the render.")
                                                    scrollToParentEnd('bottom')
                                                    
                                                }}
                                                >
                                                    <div style={{ width: 75, height:75, background:item.color }} ></div>
                                                </div>
                                        </Tooltip>
                                        )
                                    })}
                                    
                                    </div>
                                    
                                </div>
                                }]}
                                />

                                <Collapse
                                    size='large'
                                    defaultActiveKey={['1']}
                                    className='my-2'
                                    items={[{ key: '1', label: 'Control', 
                                    children: 
                                    <div>
                                        <div className={`w-full mt-5 mb-5 flex flex-col`} id='control'>
                                    <span className='hedvig-letters-sans-regular text-xl text-black p-2'>Control:</span>
                                    <div className='grid grid-cols-3 gap-3 p-2'>
                                        {controlType?.map((item:any,index:number) =>{
                                                return(
                                                
                                                        <div
                                                        key={index}
                                                        
                                                        className={`cursor-pointer flex flex-col items-center justify-center overflow-hidden rounded-lg  bg-transparent ${(currentControlType == index)?'border-2 border-solid  border-blue-500 -translate-y-1' :'border border-solid  border-gray-100'} shadow-md transform-all duration-200`}
                                                        onClick={()=>{
                                                            setCurrentControlType(index)
                                                            setControl(undefined)
                                                            setWifiControl(false)
                                                            scrollToParentEnd('control')
                                                         
                                                        }}
                                                        >
                                                            
                                                                <img
                                                                
                                                                    className="object-center object-cover w-1/2 aspect-square p-1"
                                                                    alt=""
                                                                    src={item.src}
                                                                />
                                                    
                                                            <span className='text-xs my-2'>{item.title}</span>
                                                        </div>
                                        
                                                )
                                        })}
                                    
                                    </div>
                                </div>
                                <div className={`w-full mt-5 mb-5 flex flex-col ${currentControlType==1 ? '':'hidden'}`}>
                                    <span className='hedvig-letters-sans-regular text-xl text-black p-2'>Motor Brand:</span>
                                    <div className='grid grid-cols-3 gap-3 p-2'>
                                        {motoBrand?.map((item:any,index:number) =>{
                                                return(
                                                
                                                        <div
                                                        key={index}
                                                        className={`cursor-pointer flex flex-col items-center justify-center overflow-hidden rounded-lg  bg-transparent ${(currentMotorBrand == index)?'border-2 border-solid  border-blue-500 -translate-y-1' :'border border-solid  border-gray-100'} shadow-md transform-all duration-200`}
                                                        onClick={()=>{
                                                            setCurrentMotorBrand(index)
                                                            setControlTypes(item.controls)
                                                            loadRemote(item.controls)
                                                            setControl(undefined)
                                                            setWifiControl(false)
                                                        }}
                                                        >
                                                            
                                                                <img
                                                                
                                                                    className="object-center object-cover w-1/2 aspect-square p-1"
                                                                    alt=""
                                                                    src={item.src}
                                                                />
                                                    
                                                            <span className='text-xs my-2'>{item.title}</span>
                                                        </div>
                                        
                                                )
                                        })}
                                    
                                    </div>
                                </div>
                                <div className={`w-full mt-5 mb-5 flex flex-col ${(currentControlType==1 && currentMotorBrand!= null) ? '':'hidden'}`} id='remote'>
                                    <span className='hedvig-letters-sans-regular text-xl text-black p-2'>Remote:</span>
                                    {(loadingRemote)?
                                                    <div className='flex items-center justify-center'>
                                                         <LoadingOutlined color="#000000" style={{fontSize:40}}/>
                                                    </div>
                                                   
                                                    :
                                    <div className='grid grid-cols-2 xl:grid-cols-3 gap-3 p-2'>
                                        {controlTypes?.map((item:any,index:number) =>{
                                                return(
                                                
                                                        <div
                                                        key={index}
                                                       
                                                        className={`cursor-pointer flex flex-col items-center justify-center overflow-hidden rounded-lg  bg-transparent ${(control == index)?'border-2 border-solid  border-blue-500 -translate-y-1' :'border border-solid  border-gray-100'} shadow-md transform-all duration-200`}
                                                        onClick={()=>{
                                                            setControl(index)
                                                            scrollToParentEnd('remote')
                                                        }}
                                                        >
                                                            
                                                                <img
                                                                
                                                                    className="object-center h-[10rem]  p-1"
                                                                    alt=""
                                                                    src={item.src}
                                                                />
                                                    
                                                            <span className='text-xs my-2'>{item.title}</span>
                                                        </div>
                                        
                                                )
                                        })}
                                    
                                    </div>}
                                </div>
                                <div className={`w-full mt-5 mb-5 flex flex-col ${(currentControlType==1 && (currentMotorBrand == 1 || currentMotorBrand == 3 )  ) ? '':'hidden'}`}>
                                    <span className='hedvig-letters-sans-regular text-xl text-black p-2'>Wifi Connection:</span>
                                
                                    <div className='flex flex-row gap-3 p-2'>
                                                        <div
                                                
                                                        style={{ height:200}}
                                                        className={`w-1/2 cursor-pointer flex flex-col items-center justify-center overflow-hidden rounded-lg  bg-transparent ${(wifiControl == false)?'border-2 border-solid  border-blue-500 -translate-y-1' :'border border-solid  border-gray-100'} shadow-md transform-all duration-200`}
                                                        onClick={()=>{
                                                            setWifiControl(false)
                                                        }}
                                                        >
                                                            <span className='text-xl my-2'>NO</span>
                                                        </div>
                                                        <div
                                                
                                                        style={{ height:200}}
                                                        className={`${currentMotorBrand == 1 ? "":"hidden" } w-1/2 cursor-pointer flex flex-col items-center justify-center overflow-hidden rounded-lg  bg-transparent ${(wifiControl == true)?'border-2 border-solid  border-blue-500 -translate-y-1' :'border border-solid  border-gray-100'} shadow-md transform-all duration-200`}
                                                        onClick={()=>{
                                                            setWifiControl(true)
                                                        }}
                                                        >
                                                            
                                                                <img
                                                                
                                                                    className="object-center object-cover h-5/6  p-1"
                                                                    alt=""
                                                                    src={CFCDN+'protecta/control/alpha-neo1.jpg'}
                                                                />
                                                    
                                                            <span className='text-xs my-2'>Alpha Neo Link Box</span>
                                                        </div>
                                                        <div
                                                
                                                        style={{ height:200}}
                                                        className={`${currentMotorBrand == 3 ? "":"hidden" } w-1/2 cursor-pointer flex flex-col items-center justify-center overflow-hidden rounded-lg  bg-transparent ${(wifiControl == true)?'border-2 border-solid  border-blue-500 -translate-y-1' :'border border-solid  border-gray-100'} shadow-md transform-all duration-200`}
                                                        onClick={()=>{
                                                            setWifiControl(true)
                                                        }}
                                                        >
                                                            
                                                                <img
                                                                
                                                                    className="object-center object-cover h-5/6  p-1"
                                                                    alt=""
                                                                    src={CFCDN+'protecta/control/somfy-wifi.avif'}
                                                                />
                                                    
                                                            <span className='text-xs my-2'>Connexoon Window RTS </span>
                                                        </div>
                                        
                                        
                                                
                                    </div>
                                </div>
                                <div className={`w-full mt-5 mb-5 flex flex-col ${(currentControlType==1 && currentMotorBrand == 1) ? '':'hidden'} flex flex-col`}>
                                    <span className='hedvig-letters-sans-regular text-xl text-black px-2'>Smart Sensor:</span>
                                    <span className='hedvig-letters-sans-regular text-sm text-black px-2 mb-2'>Automatically stops if an obstacle is detected to prevent motor damage.</span>
                                    <div className='flex flex-row gap-3 p-2'>
                                      
                                                
                                                        <div
                                                
                                                        style={{height:100}}
                                                        className={`w-1/2 cursor-pointer flex flex-col items-center justify-center overflow-hidden rounded-lg  bg-transparent ${(opticalDetection == false)?'border-2 border-solid  border-blue-500 -translate-y-1' :'border border-solid  border-gray-100'} shadow-md transform-all duration-200`}
                                                        onClick={()=>{
                                                            setOpticalDetection(false)
                                                        }}
                                                        >
                                                            
                                                            <span className='text-xl my-2'>No</span>
                                                        </div>
                                                        <div
                                                
                                                        style={{height:100}}
                                                        className={`w-1/2 cursor-pointer flex flex-col items-center justify-center overflow-hidden rounded-lg  bg-transparent ${(opticalDetection == true)?'border-2 border-solid  border-blue-500 -translate-y-1' :'border border-solid  border-gray-100'} shadow-md transform-all duration-200`}
                                                        onClick={()=>{
                                                            setOpticalDetection(true)
                                                        }}
                                                        >
                                                            
                                                            <span className='text-xl my-2'>Optical Detection</span>
                                                        </div>
                                        
                                        
                                                
                                    </div>
                                </div>
                                <div className={`w-full mt-5 mb-5 flex flex-col ${(currentControlType==1 ) ? '':'hidden'} flex flex-col`}>
                                    <span className='hedvig-letters-sans-regular text-xl text-black px-2'>Safety Option:</span>
                                    <span className='hedvig-letters-sans-regular text-sm text-black px-2 mb-2'>Manual override allows operation in the case of a power outage.</span>
                                    <div className='flex flex-row gap-3 p-2'>
                                      
                                                
                                                        <div
                                                
                                                        style={{height:100}}
                                                        className={`w-1/2 cursor-pointer flex flex-col items-center justify-center overflow-hidden rounded-lg  bg-transparent ${(manualOverdrive == false)?'border-2 border-solid  border-blue-500 -translate-y-1' :'border border-solid  border-gray-100'} shadow-md transform-all duration-200`}
                                                        onClick={()=>{
                                                            setManualOverdrive(false)
                                                        }}
                                                        >
                                                            
                                                            <span className='text-xl my-2'>NO</span>
                                                        </div>
                                                        <div
                                                
                                                        style={{height:100}}
                                                        className={`w-1/2 cursor-pointer flex flex-col items-center justify-center overflow-hidden rounded-lg  bg-transparent ${(manualOverdrive == true)?'border-2 border-solid  border-blue-500 -translate-y-1' :'border border-solid  border-gray-100'} shadow-md transform-all duration-200`}
                                                        onClick={()=>{
                                                            setManualOverdrive(true)
                                                        }}
                                                        >
                                                            
                                                            <span className='text-xl my-2'>Manual Overdrive</span>
                                                        </div>
                                        
                                        
                                                
                                    </div>
                                </div>
                                    </div>
                                }]}
                                />
{/*                                 
                                <div className={`w-full mt-5 mb-5 flex flex-col`}>
                                    <span className='hedvig-letters-sans-regular text-xl text-black px-2'>Installation:</span>
                                    <div className='flex flex-row gap-3 p-2'>
                                      
                                                
                                                        <div
                                                
                                                        style={{height:100}}
                                                        className={`w-1/2 cursor-pointer flex flex-col items-center justify-center overflow-hidden rounded-lg  bg-transparent ${(installation == false)?'border-2 border-solid  border-blue-500 -translate-y-1' :'border border-solid  border-gray-100'} shadow-md transform-all duration-200`}
                                                        onClick={()=>{
                                                            setInstallation(false)
                                                        }}
                                                        >
                                                            
                                                            <span className='text-xl my-2'>DIY</span>
                                                        </div>
                                                        <div
                                                
                                                        style={{height:100}}
                                                        className={`w-1/2 cursor-pointer flex flex-col items-center justify-center overflow-hidden rounded-lg  bg-transparent ${(installation == true)?'border-2 border-solid  border-blue-500 -translate-y-1' :'border border-solid  border-gray-100'} shadow-md transform-all duration-200`}
                                                        onClick={()=>{
                                                            setInstallation(true)
                                                        }}
                                                        >
                                                            
                                                            <span className='text-xl my-2'>Professional <br></br> Installation</span>
                                                        </div>
                                        
                                        
                                                
                                    </div>
                                </div> */}
                                
                                
                    </div>
                    </div>
                </div>
                </div>
                
               

                <div className='flex flex-col max-w-screen-2xl m-auto items-center justify-center mt-20 mb-10'>
                    <span className='text-2xl lg:text-5xl text-center hedvig-letters-serif-regular'>
                        Need help from our expert?
                    </span>
                    <span className='text-2xl text-center hedvig-letters-sans-regular underline transition-all duration-200 hover:translate-x-1 hover:text-neutral-500 mt-3'
                        onClick={()=>{navigate('/contact')}}
                    >
                        Contact us
                    </span>
                    
                </div>
            </Content>
         
        </div>
  )
}
